/**
 * How a place's town is SHOWN (091): what was typed, and beside it the
 * neighbourhood and who said so. "Brooklyn · Williamsburg (from the address
 * lookup)". Nothing typed is ever replaced, so nobody wonders why the page does
 * not say what they entered: it does, and it says where the rest came from.
 *
 * Which of the two a place is CALLED by (its derived name, the board) is the
 * database's `place_town()`; this is only the words beside it.
 */
export function townLabel(
  city: string | null | undefined,
  neighbourhood: string | null | undefined,
  source: 'lookup' | 'person' | null | undefined,
): string | null {
  const typed = city?.trim() || null;
  const hood = neighbourhood?.trim() || null;
  if (!hood || (typed && hood.toLowerCase() === typed.toLowerCase())) return typed;
  const said = source === 'lookup' ? ' (from the address lookup)' : '';
  return typed ? `${typed} · ${hood}${said}` : `${hood}${said}`;
}
